<template>
  <div>
    <div
      :key="'stage.value' + stageIndex"
      name="stage"
      class="mt-2"
    >
      {{ 'Этап ' + stage.name }}
    </div>

    <b-form-checkbox-group
      v-if="groupType"
      v-model="combination_dict[stage.uuid]"
      :value="combination_dict[stage.uuid] || setReactiveProperty(combination_dict, stage.uuid, [])"
      name="stage"
      @change="setStageState"
    >
      <b-form-checkbox
        :key="'stage.sex.male' + stageIndex"
        class="mt-1 mr-1"
        value="Male"
      > М </b-form-checkbox>
      <b-form-checkbox
        :key="'stage.sex.female' + stageIndex"
        value="Female"
      > Ж </b-form-checkbox>
    </b-form-checkbox-group>
  </div>
</template>
<script>
import {
  BFormInput, BFormCheckbox, BButton, BFormCheckboxGroup,
} from 'bootstrap-vue'
import Vue from 'vue'

export default {
  name: 'Stage',
  components: {
    BFormInput,
    BFormCheckbox,
    BButton,
    BFormCheckboxGroup,
  },
  props: ['stage', 'stageIndex', 'groupType', 'combination_dict'],
  data() {
    return {
    }
  },
  // created() {
  //   console.log('Stage', this.stage, this.combination_dict)
  // },
  methods: {
    setReactiveProperty(obj, key, value) {
      Vue.set(obj, key, value)
      return obj[key]
    },
    setStageState(e) {
      this.combination_dict[this.stage.uuid] = e
    },
  },
}
</script>
